import GET from "./api/GET";
import POST from "./api/POST";

export const fetchTransactions = async (
  page = 1,
  limit = process.env.REACT_APP_PAGINATION_LIMIT || 10,
  search = "",
  startDate,
  endDate,
) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/wallet/transactions?branchId=${branchId}&page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
  );
  return response;
};

export const generateWalletInvoice = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/wallet/invoice`,
    credentials,
    {
      responseType: "blob",
    }
  );
  return response;
};

export const exportTransactions = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/wallet/export-transactions`,
    credentials,
    {
      responseType: "blob",
    },
  );
  return response;
};

export const initiateBookeeyPayment = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}payment-gateway/bookeey/payment/initiate`,
    credentials,
  );
  return response;
};

export const bookeeyPaymentStatus = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}payment-gateway/bookeey/payment/status`,
    credentials,
  );
  return response;
};

export const bookeeyPaymentMethods = async () => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}payment-gateway/bookeey/payment/payment-methods`,
  );
  return response;
};
